import React, { useEffect } from "react";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import ContextOfChildComponentLegacy from "../../../components/applicationComponents/legacy/contextOfChild/ContextOfChildComponentLegacy";

export default function ContextOfChildPageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Context of the child Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ContextOfChildComponentLegacy disabled={false} />
    </>
  );
}
